import { useI18n } from '#/i18n/hooks/useI18n';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { ActionDateRange } from '#/modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from '#/modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from '#/modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from '#/modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RadiusFacet } from '#/modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from '#/modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from '#/modules/search/components/Refinements/SearchRefinements';

import { EventSourceFacet } from './EventSourceFacet';
import { IdealistDaysFilter } from './IdealistDaysFilter';

export function SearchEventsRefinements() {
  const { locale } = useI18n();

  return (
    <SearchRefinements
      listingType="EVENT"
      renderFacets={({ variant }) => {
        switch (locale) {
          case I18nLocale.EN:
            return (
              <>
                <LocationTypeFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <LocaleFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.ES:
            return (
              <>
                <LocaleFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );

          case I18nLocale.PT:
            return (
              <>
                <LocaleFacet variant={variant} />
                <IdealistDaysFilter variant={variant} />
                <LocationTypeFacet variant={variant} />
                <OrgAreasOfFocusFacet variant={variant} />
                <ActionDateRange variant={variant} />
                <EventSourceFacet variant={variant} />
                <RecencyFacet variant={variant} />
                <RadiusFacet variant={variant} />
              </>
            );
        }
      }}
    />
  );
}
